export enum Education {
  PrimarySchool = 0,
  SecondarySchool,
  BachelorDegree,
  HigherEducation,
  MasterDegree,
  DoctorDegree,
}
